/**
 * Spectrum Collection — Filter & Sort Drawers
 *
 * Manages:
 *  - Filter drawer (two-panel: category nav + values)
 *  - Sort drawer (left panel desktop / bottom sheet mobile)
 *  - Body scroll lock
 *  - AJAX product grid rendering (selective swap without full page refresh)
 */

(function () {
  'use strict';

  var SELECTORS = {
    openBtn: '[data-spectrum-open]',
    filterDrawer: '#SpectrumFilterDrawer',
    sortDrawer: '#SpectrumSortDrawer',
    backdrop: '.spectrum-drawer__backdrop',
    closeBtn: '.spectrum-drawer__close',
    navItem: '.spectrum-drawer__nav-item',
    filterPanel: '.spectrum-drawer__filter-panel',
    applyBtn: '.spectrum-drawer__apply',
    resetBtn: '.spectrum-drawer__reset',
    sortOption: '.spectrum-sort__option',
    filtersForm: '.js-spectrum-filters-form',
    dynamicSearch: 'dynamic-product-search',
    productGrid: '.collection-products',
    pagination: '.collection-pagination'
  };

  var filterDebounceTimer = null;
  var activeRequest = null;

  function init() {
    // Delegate from document — the theme's pagination handler replaces the
    // entire section innerHTML on next/prev page clicks, which would orphan
    // listeners attached to dynamic-product-search itself.
    document.addEventListener('click', handleClick);
    document.addEventListener('change', handleChange);
    document.addEventListener('keydown', handleKeydown);
  }

  function handleChange(e) {
    var input = e.target;
    // Only react to inputs inside our filter form
    if (input.closest && input.closest(SELECTORS.filtersForm)) {
      updateResetState();
      clearTimeout(filterDebounceTimer);
      filterDebounceTimer = setTimeout(function () {
        applyFilters(true);
      }, 300);
    }
  }

  function updateResetState() {
    var form = document.querySelector(SELECTORS.filtersForm);
    var resetBtn = document.querySelector(SELECTORS.resetBtn);
    if (!form || !resetBtn) return;

    var hasActiveFilters = false;
    var checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');
    if (checkboxes.length > 0) {
      hasActiveFilters = true;
    } else {
      var priceInputs = form.querySelectorAll('.price-range__number');
      for (var i = 0; i < priceInputs.length; i++) {
        if (priceInputs[i].value !== '') {
          hasActiveFilters = true;
          break;
        }
      }
    }

    resetBtn.disabled = !hasActiveFilters;
  }

  function handleClick(e) {
    var target = e.target;

    var openBtn = target.closest(SELECTORS.openBtn);
    if (openBtn) {
      e.preventDefault();
      var drawerType = openBtn.getAttribute('data-spectrum-open');
      openDrawer(drawerType);
      return;
    }

    if (target.closest(SELECTORS.closeBtn)) {
      e.preventDefault();
      closeAllDrawers();
      return;
    }

    if (target.matches(SELECTORS.backdrop)) {
      closeAllDrawers();
      return;
    }

    var navItem = target.closest(SELECTORS.navItem);
    if (navItem) {
      e.preventDefault();
      switchFilterCategory(navItem);
      return;
    }

    if (target.closest(SELECTORS.applyBtn)) {
      e.preventDefault();
      applyFilters();
      return;
    }

    var resetBtn = target.closest(SELECTORS.resetBtn);
    if (resetBtn) {
      e.preventDefault();
      var resetUrl = resetBtn.getAttribute('data-url');
      if (resetUrl) {
        renderProductGrid(resetUrl);
      }
      return;
    }

    var sortOption = target.closest(SELECTORS.sortOption);
    if (sortOption) {
      e.preventDefault();
      selectSort(sortOption);
      return;
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      closeAllDrawers();
    }
  }

  function openDrawer(type) {
    var selector = type === 'filter' ? SELECTORS.filterDrawer : SELECTORS.sortDrawer;
    var drawer = document.querySelector(selector);
    if (!drawer) return;

    drawer.classList.add('is-open');
    document.body.dataset.spectrumScrollY = window.scrollY;
    document.body.style.top = '-' + window.scrollY + 'px';
    document.body.classList.add('spectrum-drawer-open');
    if (type === 'filter') updateResetState();

    var closeBtn = drawer.querySelector(SELECTORS.closeBtn);
    if (closeBtn) {
      setTimeout(function () { closeBtn.focus(); }, 100);
    }
  }

  function closeAllDrawers() {
    var drawers = document.querySelectorAll('.spectrum-drawer.is-open');
    for (var i = 0; i < drawers.length; i++) {
      drawers[i].classList.remove('is-open');
    }
    var scrollY = parseInt(document.body.dataset.spectrumScrollY || '0', 10);
    document.body.classList.remove('spectrum-drawer-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  function switchFilterCategory(navItem) {
    var drawer = navItem.closest('.spectrum-drawer');
    if (!drawer) return;

    var index = navItem.getAttribute('data-filter-index');

    var allNav = drawer.querySelectorAll(SELECTORS.navItem);
    for (var i = 0; i < allNav.length; i++) {
      allNav[i].classList.remove('is-active');
    }
    navItem.classList.add('is-active');

    var allPanels = drawer.querySelectorAll(SELECTORS.filterPanel);
    for (var j = 0; j < allPanels.length; j++) {
      allPanels[j].classList.remove('is-active');
    }
    var targetPanel = drawer.querySelector(SELECTORS.filterPanel + '[data-filter-index="' + index + '"]');
    if (targetPanel) {
      targetPanel.classList.add('is-active');
    }
  }

  function applyFilters(keepDrawerOpen) {
    var form = document.querySelector(SELECTORS.filtersForm);
    if (!form) return;

    if (!keepDrawerOpen) {
      closeAllDrawers();
    }

    var formData = new FormData(form);
    var params = new URLSearchParams();
    var entries = formData.entries();
    var entry = entries.next();

    // Skip sort_by and q from the form — the form's hidden inputs are rendered
    // server-side and don't update when sort changes via AJAX, so they go stale.
    // We reapply them from the live URL below.
    while (!entry.done) {
      var key = entry.value[0];
      var value = entry.value[1];
      if (value !== '' && value !== undefined && key !== 'sort_by' && key !== 'q') {
        params.append(key, value);
      }
      entry = entries.next();
    }

    var currentParams = new URLSearchParams(window.location.search);
    ['sort_by', 'q'].forEach(function (key) {
      if (currentParams.has(key)) {
        params.set(key, currentParams.get(key));
      }
    });

    var baseUrl = form.getAttribute('data-url') || window.location.pathname;
    var query = params.toString();
    var url = baseUrl + (query ? '?' + query : '');

    renderProductGrid(url);
  }

  function selectSort(option) {
    var sortValue = option.getAttribute('data-sort');
    if (!sortValue) return;

    var parent = option.closest('.spectrum-drawer');
    if (parent) {
      var allOptions = parent.querySelectorAll(SELECTORS.sortOption);
      for (var i = 0; i < allOptions.length; i++) {
        allOptions[i].classList.remove('is-active');
      }
    }
    option.classList.add('is-active');

    // Keep the filter form's hidden sort_by input in sync so a follow-up
    // filter apply doesn't submit the stale server-rendered value.
    var filterSortInput = document.querySelector(SELECTORS.filtersForm + ' input[name="sort_by"]');
    if (filterSortInput) {
      filterSortInput.value = sortValue;
    }

    closeAllDrawers();

    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    renderProductGrid(url.pathname + url.search);
  }

  /**
   * AJAX product grid renderer — fetches the section HTML and selectively
   * swaps only the product grid + pagination, preserving drawers and toolbar.
   */
  function renderProductGrid(url) {
    var dynamicSearch = document.querySelector(SELECTORS.dynamicSearch);
    if (!dynamicSearch) {
      window.location.href = url;
      return;
    }

    // Abort any in-flight request
    if (activeRequest) {
      activeRequest.abort();
    }
    activeRequest = new AbortController();

    var sectionId = dynamicSearch.dataset.section;
    var query = url.split('?')[1] || '';
    var fetchUrl = (dynamicSearch.dataset.url || window.location.pathname)
      + '?' + query + '&section_id=' + sectionId;

    var section = dynamicSearch.closest('.section');
    if (section) section.classList.add('is-loading');

    fetch(fetchUrl, { signal: activeRequest.signal })
      .then(function (response) {
        if (response.ok) return response.text();
        throw new Error('Failed to fetch');
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');

        // 1. Swap product grid (cards + active filter tags)
        var newProducts = html.querySelector(SELECTORS.productGrid);
        var oldProducts = document.querySelector(SELECTORS.productGrid);
        if (newProducts && oldProducts) {
          oldProducts.innerHTML = newProducts.innerHTML;
        }

        // 2. Swap pagination
        var newPagination = html.querySelector(SELECTORS.pagination);
        var oldPagination = document.querySelector(SELECTORS.pagination);
        if (newPagination) {
          if (oldPagination) {
            oldPagination.innerHTML = newPagination.innerHTML;
          } else {
            dynamicSearch.insertAdjacentHTML('beforeend', newPagination.outerHTML);
          }
        } else if (oldPagination) {
          oldPagination.remove();
        }

        // 3. Update URL without page reload
        history.pushState({}, '', url);

        // 4. Update page title
        var newDps = html.querySelector('dynamic-product-search');
        if (newDps && newDps.dataset.pageTitle) {
          document.title = newDps.dataset.pageTitle;
        }

        // 5. Remove loading state
        if (section) section.classList.remove('is-loading');

        // 6. Re-attach DynamicProductSearch listeners on new DOM nodes
        if (typeof dynamicSearch.filtersControl === 'function') {
          dynamicSearch.filtersControl();
        }
        if (typeof dynamicSearch.paginationControl === 'function') {
          dynamicSearch.paginationControl();
        }

        // 7. Re-init scroll animations
        if (document.body.dataset.animLoad === 'true' && window.sr) {
          var sectionClass = '.section--' + sectionId;
          window.sr.reveal(sectionClass + ' .product-card-top', {
            interval: (window.theme && window.theme.intervalValue) || 100,
            delay: 0
          });
        }

        // 8. Re-init dynamic checkout buttons
        if (dynamicSearch.dataset.quickShopDynamicCheckout === 'true'
            && window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }

        activeRequest = null;
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        activeRequest = null;
        if (section) section.classList.remove('is-loading');
        // Fallback to full page navigation on error
        window.location.href = url;
      });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
